import type { LifeDimensions } from '../domain/life-state'

export interface ParticleAppearance {
  glow: number
  breathAmplitude: number
  strandCount: number
  strandReach: number
  edgeOpacity: number
  persistentSporeCount: number
  irregularity: number
}

const unit = (value: number): number =>
  Math.min(1, Math.max(0, Number.isFinite(value) ? value / 100 : 0))

const mix = (min: number, max: number, value: number): number =>
  min + (max - min) * value

export function mapLifeAppearance(dimensions: LifeDimensions): ParticleAppearance {
  const energy = unit(dimensions.energy)
  const curiosity = unit(dimensions.curiosity)
  const connection = unit(dimensions.connection)
  const memory = unit(dimensions.memory)
  const balance = Number.isFinite(dimensions.balance)
    ? Math.min(1, Math.max(0, dimensions.balance / 100))
    : 0.5

  return {
    glow: mix(0.18, 0.72, energy),
    breathAmplitude: mix(0.018, 0.065, energy),
    strandCount: Math.round(mix(5, 14, curiosity)),
    strandReach: mix(0.58, 1.3, curiosity),
    edgeOpacity: mix(0.045, 0.16, connection),
    persistentSporeCount: Math.round(mix(0, 18, memory)),
    irregularity: Number(mix(0.34, 0.02, balance).toFixed(12)),
  }
}
